export const Structure = Symbol('Structure')
